import React from 'react';
import SystemSetting from '../../components/SystemSetting';
import {isRoot} from '../../helpers';
import OtherSetting from '../../components/OtherSetting';
import PersonalSetting from '../../components/PersonalSetting';
import OperationSetting from '../../components/OperationSetting';
import TopUpPackageSettings from '../../components/TopUpPackageSettings';
import {TabPane, Tabs} from "@douyinfe/semi-ui";

const Setting = () => {
    let panes = [
        {
            tab: '👤 个人设置',
            content: <PersonalSetting/>,
            itemKey: '1'
        }
    ];

    if (isRoot()) {
        panes.push({
            tab: '💼 运营设置',
            content: <OperationSetting/>,
            itemKey: '2'
        });
        panes.push({
            tab: '💰 充值套餐',
            content: <TopUpPackageSettings/>,
            itemKey: '5'
        });
        panes.push({
            tab: '⚙️ 系统设置',
            content: <SystemSetting/>,
            itemKey: '3'
        });
        panes.push({
            tab: '🔧 其他设置',
            content: <OtherSetting/>,
            itemKey: '4'
        });
    }

    return (
        <div style={{ padding: '24px', background: '#f5f7fa', minHeight: 'calc(100vh - 60px)' }}>
            {/* 页面标题区域 - 参考首页风格 */}
            <div style={{ 
                marginBottom: '24px',
                padding: '24px',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '12px',
                color: '#fff'
            }}>
                <h2 style={{ margin: '0 0 8px 0', fontSize: '24px', fontWeight: '600' }}>
                    ⚙️ 系统设置
                </h2>
                <p style={{ margin: 0, fontSize: '14px', opacity: 0.9 }}>
                    管理个人配置、系统参数和运营选项
                </p>
            </div>

            {/* 设置内容区域 */}
            <div style={{
                background: '#fff',
                borderRadius: '8px',
                border: '1px solid #e4e7ed',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
                overflow: 'hidden'
            }}>
                <Tabs 
                    type="line" 
                    defaultActiveKey="1"
                    style={{ 
                        padding: '0 20px',
                        background: '#fff'
                    }}
                >
                    {panes.map(pane => (
                        <TabPane 
                            itemKey={pane.itemKey} 
                            tab={pane.tab}
                            style={{ padding: '20px 0' }}
                        >
                            {pane.content}
                        </TabPane>
                    ))}
                </Tabs>
            </div>
        </div>
    );
};

export default Setting;
